import * as React from "react"

import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectLabel,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select"

interface select {
	value: string;
	setValue: Function;
}

const CurrencySelect: React.FC<select> = ({ value, setValue }) => {

	React.useEffect(() => {
		if (!value) setValue("EUR");
	}, [value, setValue]);

	return (
		<Select value={value} onValueChange={(selected) => { if (selected) setValue(selected) }}>
			<SelectTrigger className="w-30 bg-input gap-4">
				<SelectValue placeholder="Currency" />
			</SelectTrigger>
			<SelectContent>
				<SelectGroup>
					<SelectLabel>Currency</SelectLabel>
					<SelectItem value="ALL">ALL</SelectItem>
					<SelectItem value="EUR">EUR</SelectItem>
					<SelectItem value="USD">USD</SelectItem>
					<SelectItem value="GPB">GPB</SelectItem>
				</SelectGroup>
			</SelectContent>
		</Select>
	)
}

export default CurrencySelect